import { ModalFullscreen, useDeviceType } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { getModalVisible, getModalStatus } from 'shared/selectors/modal';
import { ModalWrapper } from 'shared/components/ModalWrapper';
import { ModalForm } from 'shared/components/ModalForm';
import { FORM_STEPS } from 'shared/components/ModalForm/constants';
import { useMemo } from 'react';
import { selectFormStep } from 'shared/selectors/form';
import { FirstStepFormContainer } from '../FirstStepForm';
import { Form } from 'shared/components/Form';
import { SecondStepFormContainer } from '../SecondStepForm';
import { SuccessContainer } from '../Success/SuccessContainer';
import { ThirdStepFormContainer } from '../ThirdStepFormContainer';

type TModalFormContainerProps = {
  onClose: VoidFunction;
};

export const ModalFormContainer: React.FC<TModalFormContainerProps> = props => {
  const { onClose } = props;

  const modalVisible = useSelector(getModalVisible);

  const device = useDeviceType();

  const step = useSelector(selectFormStep);

  const notConditions = useSelector(getModalStatus);

  const { title, ...partialFields } = useMemo(() => FORM_STEPS[step], [step]);

  const form = (() => {
    switch (step) {
      default:
        return <FirstStepFormContainer />;
      case 1:
        return <SecondStepFormContainer />;
      case 2:
        return <ThirdStepFormContainer />;
    }
  })();

  return (
    <ModalFullscreen onClose={onClose} open={modalVisible}>
      <ModalWrapper onClose={onClose}>
        <ModalForm
          successView={<SuccessContainer />}
          step={step}
          failedStatus={notConditions}
          form={<Form title={title} device={device} form={form} currentStep={step + 1} {...partialFields} />}
        />
      </ModalWrapper>
    </ModalFullscreen>
  );
};
